var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ql-editor"},[_c(_setup.Spin,{attrs:{"spinning":_setup.loading}},[(!_vm.content)?_c(_setup.Empty):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }